<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header"><span>收益记录</span></div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="agentId" label="代理商ID" width="100" />
        <el-table-column prop="bizType" label="业务类型" width="120" />
        <el-table-column prop="amount" label="金额" width="100" />
        <el-table-column prop="sourceDesc" label="来源说明" min-width="180" show-overflow-tooltip />
        <el-table-column prop="createdAt" label="时间" min-width="160" />
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getCommissions } from '@/api/admin'
import listPage from '@/mixins/listPage'

export default {
  name: 'AgentsEarnings',
  mixins: [listPage],
  created() {
    this.loadList()
  },
  methods: {
    fetchList(params) {
      return getCommissions(params)
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
